import { FC } from "react";
import { Icon, IconName } from "Components/UI";
import { GetAvatar, ThumbType } from "Utils/generateThumbnail";
import Tooltip from "Components/UI/Tooltip";
import { BtnContainer, Container } from "./styles";

export interface IOnChangePermission {
  ID: string;
  isInvited?: boolean;
  privilege?: number;
  hasPlottingPermission: boolean;
}

interface IItem {
  ID: string;
  isInvited?: boolean;
  username: string;
  userAvatar?: string;
  userAvatarThumb?: string;
  userAvatarThumbType?: ThumbType;
  privileges: number[];
  hasPlottingPermission: boolean;
  loading?: boolean;
  onChange: (values: IOnChangePermission) => void;
}

const buttonsPermission = ['Visualizar', 'Download', 'Upload', 'Editar'];

const Item: FC<IItem> = ({
  ID,
  isInvited,
  username,
  userAvatar,
  userAvatarThumb,
  userAvatarThumbType,
  privileges,
  hasPlottingPermission,
  loading,
  onChange,
}) => {
  const changeHasPlottingPermission = () => {
    onChange({
      ID,
      isInvited,
      hasPlottingPermission: !hasPlottingPermission,
    });
  };

  const changePermissionLevel = (level: number) => {
    if (level !== 0) {
      onChange({
        ID,
        isInvited,
        privilege: level,
        hasPlottingPermission,
      });
    }
  };

  return (
    <Container>
      <div className="avatarContainer">
        <GetAvatar
          name={username}
          shape='circle'
          src={userAvatar}
          thumbSrc={userAvatarThumb}
          thumbType={userAvatarThumbType}
        />
        <span className="userName">
          {username}
        </span>
      </div>
      <div className="actionContainer">
        {buttonsPermission.map((name, i) => (
          <Tooltip title={name} key={name}>
            <BtnContainer
              hasprivileges={privileges.includes(i)}
              isdisabled={loading}
              onClick={() => loading ? undefined : changePermissionLevel(i)}
            >
              <Icon
                icon={name.toLowerCase() as IconName}
                customSize={20}
                className="iconPermissionBtn"
              />
            </BtnContainer>
          </Tooltip>
        ))}
        <Tooltip title="Plotagem">
          <BtnContainer
            hasprivileges={hasPlottingPermission}
            isdisabled={loading}
            onClick={loading ? undefined : changeHasPlottingPermission}
          >
            <Icon
              icon="menuPlotagem"
              customSize={20}
              className="iconPermissionBtn"
            />
          </BtnContainer>
        </Tooltip>
      </div>
    </Container>
  )
}

export default Item;
